export enum AutoCompleteOperator {
	IndexOfCaseInSensitive,
	IndexOfCaseSensitive,
	Length
}
